import { CakeVariantOutlineIcon } from './CakeVariantOutlineIcon';

/**
 * author: Google
 * id 0819B4B2-9D58-438F-943E-E628A3D5BF52
 * name cake-variant-outline
 * version: 6.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/cake-variant-outline.svg
 * tags
 * - Holiday 
 * - Food / Drink 
 */
export const BirthdayCakeOutlineIcon = CakeVariantOutlineIcon;
export default BirthdayCakeOutlineIcon